import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useContent } from '../contexts/ContentContext';
import './Footer.css';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { content } = useContent();
  const lang = i18n.language?.startsWith('sk') ? 'Sk' : 'En';
  const c = content.contact;
  const branding = content.branding || {};

  const aboutText = i18n.language?.startsWith('sk')
    ? 'ZEL je multi-brand foodservice spoločnosť pôsobiaca v reštauračných, fast-food a kávových konceptoch. Náš prístup je postavený na jasnosti, konzistentnosti a dlhodobej štruktúre.'
    : 'ZEL is a multi-brand foodservice company operating across restaurant, fast-food, and coffee concepts. Our approach is built on clarity, consistency, and long-term structure.';

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <img
            src={branding.logoUrl || '/logo.png'}
            alt="ZEL s.r.o."
            className="footer__logo"
          />
          <p className="footer__tagline">{aboutText}</p>
        </div>

        <div className="footer__col">
          <h4>{i18n.language?.startsWith('sk') ? 'Rýchle odkazy' : 'Quick Links'}</h4>
          <Link to="/">{t('nav.home')}</Link>
          <Link to="/about">{t('nav.about')}</Link>
          <Link to="/contact-us">{t('nav.contact')}</Link>
        </div>

        <div className="footer__col">
          <h4>{i18n.language?.startsWith('sk') ? 'Kontakt' : 'Get In Touch'}</h4>
          <span className="footer__company">ZEL s. r. o.</span>
          <span>Pri smaltovni 3603/4</span>
          <span>851 01 Bratislava – Petržalka</span>
          <span>{i18n.language?.startsWith('sk') ? 'Slovensko' : 'Slovakia'}</span>
          <a href={`mailto:${c.email}`} style={{ marginTop: 14 }}>Email: {c.email}</a>
          <a href={`tel:${c.phone.replace(/\s/g,'')}`}>Phone: {c.phone}</a>
          <span>Hours: {c[`hours${lang}`] || 'Mon-Fri 10:00AM - 9:00PM'}</span>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {new Date().getFullYear()} ZEL s.r.o. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
